import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss']
})
export class LanguagesComponent implements OnInit {

  constructor() { }

  setAndGo(lang) {
    localStorage.setItem('lang', lang);
    window.location.href = lang;
  }

  ngOnInit() {
  }

}
